import axios from "axios";

// Server-side renders call our own API. Through the public hostname every
// call left this box, crossed Cloudflare and came back in: ~38% of the zone's
// traffic, and on 14/09 a two-minute blip on that route took the whole site
// down with 500s (#23177). With AXIOS_INTERNAL_ORIGIN set (http://127.0.0.1)
// they go to the local nginx instead, keeping the public Host, so the API
// sees the same vhost, logs and cache keys as before. Browser calls are not
// touched. Remove the variable and reload to switch back.
const toInternal = (internalOrigin) => {
  const publicOrigin = new URL(process.env.axiosUrl).origin;
  const host = new URL(publicOrigin).host;
  const internal = internalOrigin.replace(/\/+$/, "");
  const swap = (u) =>
    typeof u === "string" && u.startsWith(publicOrigin + "/")
      ? internal + u.slice(publicOrigin.length)
      : null;
  return (config) => {
    const url = swap(config.url);
    const baseURL =
      !url && !/^https?:\/\//.test(config.url || "") ? swap(config.baseURL) : null;
    if (url || baseURL) {
      if (url) {
        config.url = url;
      } else {
        config.baseURL = baseURL;
      }
      config.headers = config.headers || {};
      config.headers.Host = host;
    }
    return config;
  };
};

export default ({
  req,
  res,
  route,
  app,
  $axios,
  $config,
  redirect,
  env
}) => {
  // no call had a timeout, so one slow backend response made SSR renders
  // (and their sockets) pile up across all workers
  $axios.defaults.timeout = parseInt(process.env.AXIOS_TIMEOUT_MS || "15000");
  $axios.onRequest((config) => {
    if(config.headers.common && !(config.headers.common||{}).shopster){
      if(process.server){
        config.headers.common.shopster = req.headers.host + route.fullPath.split('-')[0]
      }else{
        config.headers.common.shopster = location.host + route.fullPath.split('-')[0]
      }
    }
  });
  if (process.server && ($config || {}).axiosInternalOrigin) {
    const rewrite = toInternal($config.axiosInternalOrigin);
    $axios.onRequest(rewrite);
    // Pages and serverMiddleware also import axios directly. That module is
    // shared by every request in this process, so it gets the interceptor
    // once, marked on the module itself.
    if (!axios.__internalApi) {
      axios.__internalApi = true;
      axios.interceptors.request.use(rewrite);
    }
  }
}
